import React from "react";
import { Card, Form, Row, Col, Button, Accordion, Image } from "react-bootstrap";
import { useUploadFile } from "../../../../../../api/fileUpload/fileUpload.hooks";

const TeamSection = ({ data, onUpdate }) => {
  const { upload, isLoading: isUploading } = useUploadFile();

  const addTeamMember = () => {
    const newMember = {
      id: Date.now().toString(),
      name: "",
      designation: "",
      image: "",
    };
    onUpdate({
      ...data,
      teamMembers: [...data.teamMembers, newMember]
    });
  };

  const removeTeamMember = (index) => {
    const updated = data.teamMembers.filter((_, i) => i !== index);
    onUpdate({
      ...data,
      teamMembers: updated
    });
  };

  const updateTeamMember = (index, field, value) => {
    const updated = data.teamMembers.map((item, i) => 
      i === index ? { ...item, [field]: value } : item
    );
    onUpdate({
      ...data,
      teamMembers: updated
    });
  };

  const handleSectionChange = (field, value) => {
    onUpdate({
      ...data,
      [field]: value
    });
  };

  const handleImageUpload = async (index, file) => {
    try {
      const res = await upload(file);
      if (res?.url) {
        updateTeamMember(index, 'image', res.url);
      }
    } catch (err) {
      console.error("File upload failed:", err);
    }
  };

  return (
    <Card className="mb-4 shadow">
      <Card.Header className="bg-neutral-gray text-dark d-flex justify-content-between align-items-center">
        <h5 className="mb-0 text-dark">Team Section</h5>
        <Form.Check
          type="checkbox"
          label="Visible"
          checked={data.isVisible}
          onChange={(e) => handleSectionChange('isVisible', e.target.checked)}
          className="mb-0"
        />
      </Card.Header>
      {data.isVisible && (
        <Card.Body>
          <Row className="mb-4">
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Heading</Form.Label>
                <Form.Control
                  type="text"
                  value={data.heading}
                  onChange={(e) => handleSectionChange('heading', e.target.value)}
                  placeholder="Enter heading"
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Sub Heading</Form.Label>
                <Form.Control
                  type="text"
                  value={data.subHeading}
                  onChange={(e) => handleSectionChange('subHeading', e.target.value)}
                  placeholder="Enter sub heading"
                />
              </Form.Group>
            </Col>
          </Row>

          <div className="d-flex justify-content-between align-items-center mb-3">
            <h6>Team Members</h6>
            <Button variant="outline-primary" size="sm" onClick={addTeamMember}>
              Add Team Member
            </Button>
          </div>

          <Accordion>
            {data.teamMembers.map((member, index) => (
              <Accordion.Item key={member.id || index} eventKey={index.toString()}>
                <Accordion.Header>
                  Member {index + 1}: {member.name || "Unnamed"}
                </Accordion.Header>
                <Accordion.Body>
                  <Row>
                    <Col md={12} className="mb-3">
                      <div className="d-flex justify-content-end">
                        <Button
                          variant="outline-danger"
                          size="sm"
                          onClick={() => removeTeamMember(index)}
                        >
                          Remove
                        </Button>
                      </div>
                    </Col>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label>Name</Form.Label>
                        <Form.Control
                          type="text"
                          value={member.name}
                          onChange={(e) => updateTeamMember(index, 'name', e.target.value)}
                          placeholder="Enter name"
                        />
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label>Designation</Form.Label>
                        <Form.Control
                          type="text"
                          value={member.designation}
                          onChange={(e) => updateTeamMember(index, 'designation', e.target.value)}
                          placeholder="Enter designation"
                        />
                      </Form.Group>
                    </Col>
                    <Col md={12}>
                      <Form.Group className="mb-3">
                        <Form.Label>Image</Form.Label>
                        <Form.Control
                          type="file"
                          accept="image/*"
                          onChange={(e) =>
                            e.target.files?.[0] && handleImageUpload(index, e.target.files[0])
                          }
                        />
                        {isUploading && (
                          <div className="text-muted small mt-1">
                            Uploading...
                          </div>
                        )}
                        {member.image && (
                          <div className="mt-2">
                            <Image
                              src={member.image}
                              alt="Preview"
                              thumbnail
                              style={{ maxWidth: "200px" }}
                            />
                          </div>
                        )}
                      </Form.Group>
                    </Col>
                  </Row>
                </Accordion.Body>
              </Accordion.Item>
            ))}
          </Accordion>
        </Card.Body>
      )}
    </Card>
  );
};

export default TeamSection;
